<template>
  <div>
    <div class="steps">
      <el-steps :active="active" align-center>
        <el-step title="企业账号注册"></el-step>
        <el-step title="企业信息认证"></el-step>
        <el-step title="企业联系信息"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div v-if="active == 0" class="edit_item">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="账号" prop="login_name">
          <el-input v-model="ruleForm.login_name"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="next('ruleForm')">下一步</el-button>
          <el-link style="float: right;margin-top: 5px;" @click="login" type="primary">使用已有账户登录</el-link>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="active == 1">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="10">
            <el-form-item class="license_imge_css" prop="license_imge">
              <el-upload action :http-request="uploadOss" :on-success="uploadCover" :show-file-list="false" name="image"
                style="margin-left:-120px;">
                <i v-if="ruleForm.license_imge == ''" class="el-icon-upload" style="font-size:50px;"></i>
                <div v-if="ruleForm.license_imge == ''" class="el-upload__text">上传营业执照(格式为*.png/*.jpeg/*.jpg等)</div>

                <el-image fit="contain" style="width: 181px; height: 256px" v-if="ruleForm.license_imge !== ''"
                  :src="ruleForm.license_imge"></el-image>


              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="14" class="enter_form">
            <el-form-item label="企业LOGO:" prop="logo">
              <el-upload action :http-request="uploadOss" :on-success="logoUploadCover" :show-file-list="false"
                name="image">
                <el-avatar :size="150" style="margin-left: 80px;">
                  <el-image fit="cover" v-if="ruleForm.logo !== ''" :src="ruleForm.logo" style="width: 100%;height: 100%;" />
                  <i style="font-size:50px;padding-top: 49px;" class="el-icon-plus avatar-uploader-icon"></i>
                </el-avatar>
              </el-upload>
            </el-form-item>
            <el-form-item label="企业名称:" prop="firm_name">
              <el-input class="input_css" v-model="ruleForm.firm_name" placeholder="请输入企业名称"></el-input>
            </el-form-item>
            <el-form-item label="组织机构代码:" prop="firm_num">
              <el-input class="input_css" v-model="ruleForm.firm_num" placeholder="请输入组织机构代码"></el-input>
            </el-form-item>
            <el-form-item label="企业法人代表:" prop="legal_person">
              <el-input class="input_css" v-model="ruleForm.legal_person" placeholder="请输入企业法人代表"></el-input>
            </el-form-item>
            <el-form-item label="企业邮编:" prop="enter_postcode">
              <el-input class="input_css" v-model="ruleForm.enter_postcode" placeholder="请输入企业邮编"></el-input>
            </el-form-item>
            <el-form-item label="成立日期:" prop="establish_date">
              <el-date-picker
                  class="input_css"
                  v-model="ruleForm.establish_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择成立日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="注册资本:" prop="register_capital">
              <el-input-number class="input_css" controls-position="right" placeholder="请输入注册资本" :min="1" v-model="ruleForm.register_capital">
              </el-input-number> 万元
            </el-form-item>
            <el-form-item label="企业性质:" prop="info">
              <el-select class="input_css" v-model="ruleForm.info" placeholder="请选择" clearable>
                <el-option
                    v-for="(v,k) in qyxz"
                    :key="k"
                    :label="v"
                    :value="k">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业规模:" prop="unit_size">
              <el-select class="input_css" v-model="ruleForm.unit_size" placeholder="请选择" clearable>
                <el-option
                    v-for="(v,k) in unitSize"
                    :key="k"
                    :label="v"
                    :value="k">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所在地区:" prop="area_id">
              <el-cascader class="input_css" v-model="ruleForm.area_id" :options="cityOptions" clearable
                placeholder="请选择所在地区"></el-cascader>
            </el-form-item>
            <el-form-item label="企业地址:" prop="address">
              <el-input class="input_css" v-model="ruleForm.address" placeholder="请输入企业地址"></el-input>
            </el-form-item>
            <el-form-item label="所属行业" prop="industry_id">
              <el-cascader class="input_css" v-model="ruleForm.industry_id" :options="options"
                :props="{ value: 'id', label: 'industry_name' }" clearable placeholder="请选择所属行业"></el-cascader>
            </el-form-item>
            <el-form-item label="企业简介:" prop="enter_desc">
              <el-input class="input_css" type="textarea" placeholder="请输入企业简介" maxlength="500" show-word-limit rows="5"
                v-model="ruleForm.enter_desc"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="next('ruleForm')" type="primary">下一步</el-button>
              <el-button @click="goup()">上一步</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div v-if="active == 2">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
        <el-col :span="24" style="padding-left: 35%">
          <el-form-item label="企业联系人:" prop="firm_principal">
            <el-input class="input_css" v-model="ruleForm.firm_principal" placeholder="请输入企业联系人"></el-input>
          </el-form-item>
          <el-form-item label="职务:" prop="job">
            <el-input class="input_css" v-model="ruleForm.job" placeholder="请输入职务"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="tel">
            <el-input class="input_css" v-model="ruleForm.tel" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱:" prop="email">
            <el-input class="input_css" v-model="ruleForm.email" placeholder="请输入电子邮箱"></el-input>
          </el-form-item>
          <!-- <el-form-item v-if="optionsXnlxr" label="校内联系人:">
            <el-cascader class="input_css" v-model="ruleForm.xnlxr" :options="optionsXnlxr"
              :props="{ value: 'tel', label: 'name' }" clearable placeholder="请选择校内联系人"></el-cascader>
          </el-form-item> -->
          <el-form-item v-if="pmid!=220&&optionsXnlxr" label="校内联系人:">
            <el-cascader class="input_css" v-model="ruleForm.xnlxr" :options="optionsXnlxr"
              :props="{ value: 'tel', label: 'name' }" clearable placeholder="请选择校内联系人"></el-cascader>
          </el-form-item>
         
          <el-form-item v-if="pmid == 220" label=" 校内联系人:">
            <el-input class="input_css" v-model="ruleForm.xnlxr" placeholder="请输入校内联系人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="submit('ruleForm')" type="primary">提 交</el-button>
            <el-button @click="goup()">上一步</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
    <div v-if="active == 3">
      <el-form label-width="100px">
        <el-col :span="24" style="text-align: center;">
          <el-form-item>
            <i class="el-icon-circle-check" style="color:#67C23A;font-size:50px;"></i>
            <h3>你的账户:{{ ruleForm.firm_name }}注册成功</h3>
            <h5>激活邮件已发送到你的{{ ruleForm.email }}邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。</h5>
            <h4>
              未收到邮件?
              <el-link @click="sendEmail()" type="primary">点此重发</el-link>
            </h4>
          </el-form-item>
          <el-form-item>
            <el-button @click="hrefEmail()" type="primary">查看邮箱</el-button>
            <el-button @click="login()">返回登录</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>

<script>
import citys from "@/utils/area.json";
export default {
  data() {
    var validateAreaId = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error("请选择所在地区!"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写电子邮箱!"));
      } else {
        let regex = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/
        if(!regex.test(value)){
          callback(new Error("请填写正确的电子邮箱!"));
        } else {
          callback();
        }
      }
    };
    var validateTel = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写联系电话!"));
      } else {
        let isPhone = /^1[3456789]\d{9}$/;
        let isMob=/^((0\d{2,3})-)?(\d{7,8})$/;
        if(isMob.test(value)||isPhone.test(value)){
          callback();
        } else {
          callback(new Error("请填写正确的联系电话!"));
        }
      }
    };
    var validateFirmPrincipal = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写企业联系人!"));
      } else {
        callback();
      }
    };
    var validateEnterDesc = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写企业简介!"));
      } else {
        callback();
      }
    };
    var validateIndustryId = (rule, value, callback) => {
      if (!value || value.length == 0) {
        callback(new Error("请选择所属行业!"));
      } else {
        callback();
      }
    };
    var validateAddress = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请填写企业地址!"));
      } else {
        callback();
      }
    };
    var validateLicenseImge = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请上传营业执照图片!"));
      } else {
        callback();
      }
    };
    var validateLogo = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请上传公司LOGO图片!"));
      } else {
        callback();
      }
    };
    var validateFirmNum = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入组织机构代码"));
      } else {
        let regx = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/
        if (!regx.test(value)) {
          callback(new Error("组织机构代码格式错误"));
        } else {
          callback();
        }
      }
    };
    var validateFirmName = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入企业名称"));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value.trim() === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePostcode = (rule,value,callback) => {
      if (value.trim()) {
        let regx = /^[0-9]{6}$/
        if (!regx.test(value)) {
          callback(new Error("邮政编码格式错误"));
        }
      }
      callback();
    }
    return {
      active: 0,
      options: [],
      optionsXnlxr: [],
      cityOptions: [],
      qyxz: [],
      unitSize: [],
      id: 0,
      ruleForm: {
        login_name: "",
        password: "",
        checkPass: "",
        license_imge: "",
        logo: "",
        firm_name: "",
        firm_num: "",
        address: "",
        industry_id: "",
        area_id: "",
        enter_desc: "",
        firm_principal: "",
        tel: "",
        email: "",
        xnlxr: "",
        pmid: window.pmid,
        info:"",
        unit_size:"",
        enter_postcode:"",
        establish_date:"",
        register_capital:"",
        legal_person:"",
        job:""
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur",required: true }],
        checkPass: [{ validator: validatePass2, trigger: "blur",required: true }],
        login_name: [{ validator: validateUsername, trigger: "blur",required: true }],
        firm_name: [{ validator: validateFirmName, trigger: "blur",required: true }],
        firm_num: [{ validator: validateFirmNum, trigger: "blur",required: true }],
        license_imge: [{ validator: validateLicenseImge, trigger: "blur",required: true }],
        logo: [{ validator: validateLogo, trigger: "blur",required: true }],
        address: [{ validator: validateAddress, trigger: "blur",required: true }],
        industry_id: [{ validator: validateIndustryId, trigger: "blur",required: true }],
        area_id: [{ validator: validateAreaId, trigger: "blur",required: true }],
        enter_desc: [{ validator: validateEnterDesc, trigger: "blur",required: true }],
        firm_principal: [{ validator: validateFirmPrincipal, trigger: "blur",required: true }],
        tel: [{ validator: validateTel, trigger: "blur",required: true }],
        email: [{ validator: validateEmail, trigger: "blur",required: true }],
        enter_postcode: [{ validator: validatePostcode, trigger: "blur" }],
        legal_person: [{required: true, message: '请输入法人代表',trigger: 'blur'}],
        establish_date: [{required: true, message: '请选择成立日期',trigger: 'change'}],
        info: [{required: true, message: '请选择企业类型',trigger: 'change'}],
        unit_size: [{required: true, message: '请选择企业规模',trigger: 'change'}],
        register_capital: [{required: true, message:'请输入注册资本',trigger: 'blur'}],
        job: [{required: true, message:'请输入职位',trigger: 'blur'}],
      },
      pmid: window.pmid,
    };
  },
  mounted() {
    this.$http
      .post("/api/zp_industry_tree", { pmid: window.pmid })
      .then(res => {
        if (res && res.data && res.data.tree) {
          this.options = res.data.tree;
        }
      });
    this.$http
      .post("/api/sch_config", {
        pmid: window.pmid,
        ktype: "ktype",
        keyword: "xnlxr"
      })
      .then(res => {
        if (res && res.data.length > 0) {
          this.optionsXnlxr = JSON.parse(res.data[0].kvalue);
        }
      });
    this.cityOptions = citys;
    this.getComType()
  },
  methods: {
    getComType() {
      this.$http
          .post("/api/sys_param_list", {
            param_type:
                "'ENTER_INFO','UNIT_SIZE'",
            used: 0,
            pmid: window.pmid
          })
          .then(res => {
            let qyxz = {}; //企业性质
            let xlyq = {}; //学历类型
            let wyyq = {}; //外语要求
            let jsjyq = {}; //计算机要求
            let unitSize = {}
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz[item.param_value] = item.param_desc;
              }
              if (item.param_type == "EDUACTION") {
                xlyq[item.param_value] = item.param_desc;
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq[item.param_value] = item.param_desc;
              }
              if (item.param_type == "UNIT_SIZE") {
                unitSize[item.param_value] = item.param_desc;
              }
            }
            this.qyxz = qyxz;
            this.xlyq = xlyq;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            this.unitSize = unitSize
          });
    },
    login() {
      this.$router.push("/login");
    },
    next(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post("/api/enterprise_list_data", {
              login_name: this.ruleForm.login_name,
              pmid: window.pmid
            })
            .then(res => {
              if (res.data.length > 0) {
                this.$message({
                  message: "账号已存在",
                  type: "error",
                  offset: "600"
                });
              } else {
                this.active += 1;
              }
            });
        } else {
          return false;
        }
      });
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.area_id = this.ruleForm.area_id[
            this.ruleForm.area_id.length - 1
          ];
          this.ruleForm.industry_id = this.ruleForm.industry_id[
            this.ruleForm.industry_id.length - 1
          ];
          this.$http
            .post("/api/enterprise_enrolled", this.ruleForm)
            .then(res => {
              if (res.data) {
                this.id = res.data.id;
                this.sendEmail();
              }
              this.active += 1;
            });
          this.sendSms();
        } else {
          return false;
        }
      });
    },
    sendEmail() {
      this.$http
        .post("/api/enterprise_email_attest", {
          id: this.id,
          pmid: window.pmid
        })
        .then(res => {
          this.$message({
            type: "success",
            message:
              "激活邮件已发送到" +
              this.ruleForm.email +
              "邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户，以确保能收到简历。"
          });
        });
    },
    sendSms() {
      console.log("给校内联系人发送短信!", this.ruleForm.xnlxr);
    },
    goup() {
      this.active -= 1;
    },
    hrefEmail() {
      let userEmail = this.ruleForm.email;
      var arr1 = userEmail.split("@");
      var arr2 = arr1[1].split(".");
      window.location.href = "http://mail." + arr2[0] + ".com";
    },
    uploadCover(e) {
      this.ruleForm.license_imge = e.src;
      this.$http.post("/api/yyzz_ocr", { img_url: e.src }).then(res => {
        if (res.data.words_result) {
          console.log(res.data.words_result)
          this.ruleForm.firm_name = res.data.words_result['单位名称'].words
          this.ruleForm.firm_num = res.data.words_result['社会信用代码'].words
          this.ruleForm.address = res.data.words_result['地址'].words
          this.ruleForm.legal_person = res.data.words_result['法人'].words
          this.ruleForm.establish_date = res.data.words_result['成立日期'].words != '无' ? res.data.words_result['成立日期'].words.replace(/(\d+)年(\d+)月(\d+)日/, '$1-$2-$3') : ''
          this.ruleForm.register_capital = res.data.words_result['注册资本'].words.replace(/[^\d.]/ig,"")
        } else {
          this.$message.error("请上传清晰的营业执照！")
        }
      })
    },
    logoUploadCover(e) {
      this.ruleForm.logo = e.src;
    }
  }
};
</script>
<style scoped>
.steps {
  max-width: 750px;
  padding: 50px;
  margin: 0 auto;
}

.edit_item {
  max-width: 450px;
  margin: 150px auto;
}

.el-icon-upload {
  height: 100%;
  margin: 50px auto;
}

.license_imge_css {
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  width: 181px;
  height: 256px;
  float: right;
  margin-right: 25px;
}

.input_css {
  width: 430px;
}

.el-button {
  width: 100px;
}
</style>
